// extracted by mini-css-extract-plugin
export default {"bold-heading-text":"student-form_bold-heading-text__swIOw","button":"student-form_button__KCfnN","question-field__label":"student-form_question-field__label__Y3OOj"};